<template>
    <Box :title="'科室验收('+Total+'台)'">
        <LoadingFooter
            v-model="loading"
            :finished="finished"
            @load="onLoad"
        >
            <div class="commonItems" v-for="item in List" @click="$router.push({name: 'ExamineReceive', params: {item}})">
                <div>
                    <img src="@/assets/img/Icon_1.png"/>
                    <div>
                        <p class="ellipsis">{{item.EquName}}</p>
                        <div>
                            <div>
                                <p>资产编号：</p>
                                <p>规格型号：</p>
                                <p>使用科室：</p>
                            </div>
                            <div>
                                <p class="ellipsis">{{item.EquCode}}</p>
                                <p class="ellipsis">{{item.Size}}</p>
                                <p class="ellipsis">{{item.DepartmentName}}</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div>去验收</div>
                    </div>
                </div>
                <div>
                    <span>启用日期</span>
                    <span>{{item.EnableDate}}</span>
                </div>
            </div>
        </LoadingFooter>
    </Box>
</template>

<script>
    import Box from '../../components/commonBox/commonBox'
    import LoadingFooter from '../../components/loadingFooter/loadingFooter'
    export default {
        name: 'ExamineReceiveList',
        components: {
            Box,
            LoadingFooter
        },
        data() {
            return {
                loading: true,
                finished: false,
                List:[],
                page:1,
                Total:0,
            }
        },
        activated(){
           this.Total=0;
		   this.page=1;
           this.List=[];
           this.loadDataDefault();
        },
        methods: {
            onLoad() {
                if (!this.loading && !this.finished) {
                    this.page += 1;
                    this.loadDataDefault();
                }
            },loadDataDefault(){
                  this.$post('api/Dispatch/DispatchList',{
                      RepairStatus:'9',
                      EquCode:'',
                      RepairOrder:'',
                      DepartmentId:'',
                      UserCode:this.$UserInfo.UserId,
                      Store:this.$UserInfo.StoreCode,
                      SortType:'',
                      AssignOrConfirm:'1',
                      StartDate:'',
                      EndDate:'',
                      PageIndex:this.page,
                      PageSize:10,
                      Token:'123456'
                  }).then(result=>{
                      this.Total=result.Total;
                      if(result.DispatchList){
                          for(let i=0;i<result.DispatchList.length;i++){
                              this.List.push(result.DispatchList[i]);
                          }
                      }
                      if (this.page*10 >= result.Total) {
                          this.loading = false;
                          this.finished = true;
                      }else this.loading=false;
                  })
            }
        }
    }
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/page/examineReceiveList/examineReceiveList.vue